export const PREDICTOR_VISUAL_TAGS_LABELS = {
    'Optimization metric': 'Optimization metric',
    'Training Scheme': 'Training Scheme',
    'Cleaning': 'Cleaning',
    'Splitting Scheme': 'Splitting Scheme',
    'Optimized binary threshold': 'Optimize for precision',
    'Non-SMILES Features': 'Non-SMILES Features',
    'Reactive Functional Group': 'Reactive Functional Group'
}